import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center">
      <div className="container-editorial max-w-2xl text-center">
        <p className="eyebrow text-forest">404</p>
        <h1 className="heading-1 mt-4">This page hasn't been written yet.</h1>
        <p className="lead mt-6">
          If a translation is in progress, please try the English version. Otherwise, use the search or head home.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" className="btn-primary">Home</Link>
          <Link to="/articles" className="btn-ghost">Articles</Link>
          <Link to="/search" className="btn-ghost">Search</Link>
        </div>
      </div>
    </section>
  );
}
